import { Card, CardContent } from '@/shared/ui/card';
import { PublicInviteRichText } from './public-invite-rich-text';

interface LoyaltyRule {
  label: string;
  value: string;
}

interface PublicInviteLoyaltyRulesCardProps {
  rules: LoyaltyRule[];
}

/** Aba "Regra de Fidelidade" do tab switcher — antes era um modal, virou card inline por pedido do time. */
export function PublicInviteLoyaltyRulesCard({ rules }: PublicInviteLoyaltyRulesCardProps) {
  return (
    <Card className="mx-auto w-full max-w-xl">
      <CardContent className="space-y-4 pt-5">
        {rules.map((rule) => (
          <div key={rule.label}>
            <h3 className="text-sm font-semibold">{rule.label}</h3>
            <PublicInviteRichText html={rule.value} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
